import { profileAwarePathAutotiler } from './profileAwarePathAutotiler';
import type { PathAutotiler } from './PathAutotiler';

export const pathAutotiler: PathAutotiler = profileAwarePathAutotiler;
